import React, { useState, useEffect } from "react";
import { Line, Text } from "react-konva";
import { useSelector, useDispatch } from "react-redux";
import { updatedAbstacles } from "../../../../Features/roofInfo";
import { getPixelsPerMeter } from "../structurePlacementFunction/smithStructure";

export default function Abstacles({
  points,
  index,
  stageRef,
  dragPos,
  zoomValue,
}) {
  const dispatch = useDispatch();
  const designParameter = useSelector((state) => state.designParameter);
  const gridInfo = useSelector((state) => state.grid);
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const polygonIndex = index;
  const [area, setArea] = useState([]);

  const view = roofInfo.value.mapOption.mapTypeId;
  const abstacles = roofInfo?.value?.abstacles || [];

  let updatePoints =
    abstacles.length > 0 && index <= abstacles.length - 1
      ? abstacles[index].updatedPoints
      : points;
  const arrayLength = points.length - 1;
  const [lineHover, setLineHover] = useState();
  var specificPoint;

  useEffect(() => {
    if (polygonIndex !== 0) {
      const array = updatePoints.flatMap((point) => [point.x, point.y]);
      setArea(array);
    } else {
      if (polygonIndex === 0 && abstacles.length > 0) {
        const array = updatePoints.flatMap((point) => [point.x, point.y]);
        setArea(array);
      }
    }
    // eslint-disable-next-line
  }, [updatePoints]);

  const addNode = (index) => {
    if (quantityInfo.abstacleNo !== polygonIndex) return;
    if (designParameter.drawAbstacle || designParameter.drawPolygon) {
      return false;
    }
    specificPoint = stageRef.current.getPointerPosition();
    specificPoint = {
      x: (specificPoint.x - dragPos.x) / zoomValue,
      y: (specificPoint.y - dragPos.y) / zoomValue,
    };
    let array = [...updatePoints];
    let changeArray = [];
    for (let i = 0; i < array.length; i++) {
      if (i === index - 1 && index - 1 === arrayLength) {
        changeArray.push(array[i]);
        changeArray.push(specificPoint);
      } else if (i === index) {
        changeArray.push(specificPoint);
        changeArray.push(array[i]);
      } else {
        changeArray.push(array[i]);
      }
    }

    const updatedPolygon = [...abstacles];
    updatedPolygon[polygonIndex] = changeArray;
    dispatch(
      updatedAbstacles({
        index: polygonIndex,
        value: { updatedPoints: changeArray },
      })
    );
  };

  return updatePoints.map((point, index) => (
    <React.Fragment key={index}>
      {index > 0 && (
        <Line
          points={[
            updatePoints[index - 1].x,
            updatePoints[index - 1].y,
            point.x,
            point.y,
          ]}
          stroke={
            designParameter.abstacleEdit &&
            quantityInfo.abstacleNo === polygonIndex &&
            designParameter.lineNo === index - 1
              ? "blue"
              : "red"
          }
          strokeWidth={
            index === lineHover && quantityInfo.abstacleNo === polygonIndex
              ? 6
              : quantityInfo.abstacleNo === polygonIndex && designParameter.abstacleEdit
              ? 3
              : 1
          }
          onMouseEnter={() => setLineHover(index)}
          onMouseLeave={() => setLineHover()}
          onDblClick={() => addNode(index)}
        />
      )}
      {index > 0 &&
        quantityInfo.abstacleNo === polygonIndex &&
        designParameter.abstacleEdit && (
          <Text
            x={xPlacement(updatePoints[index - 1], point, updatePoints)}
            y={yPlacement(updatePoints[index - 1], point, updatePoints)}
            text={`${calculateDistance(
              updatePoints[index - 1],
              point,
              roofInfo,
              gridInfo
            )}`}
            rotation={rotation(updatePoints[index - 1], point)}
            fontFamily="italic"
            fontSize={10}
            fill={view === "satellite" ? "white" : "blue"}
            strokeWidth={1}
          />
        )}
      {index === arrayLength && (
        <>
          <Line
            points={[
              updatePoints[arrayLength].x,
              updatePoints[arrayLength].y,
              updatePoints[0].x,
              updatePoints[0].y,
            ]}
            stroke={
              designParameter.abstacleEdit &&
              quantityInfo.abstacleNo === polygonIndex &&
              designParameter.lineNo === arrayLength
                ? "blue"
                : "red"
            }
            strokeWidth={
              arrayLength + 1 === lineHover && quantityInfo.abstacleNo === polygonIndex
                ? 6
                : quantityInfo.abstacleNo === polygonIndex && designParameter.abstacleEdit
                ? 3
                : 1
            }
            onMouseEnter={() => setLineHover(arrayLength + 1)}
            onMouseLeave={() => setLineHover()}
            onDblClick={() => addNode(index)}
          />
          {quantityInfo.abstacleNo === polygonIndex &&
            designParameter.abstacleEdit && (
              <Text
                x={xPlacement(
                  updatePoints[arrayLength],
                  updatePoints[0],
                  updatePoints
                )}
                y={yPlacement(
                  updatePoints[arrayLength],
                  updatePoints[0],
                  updatePoints
                )}
                text={`${calculateDistance(
                  updatePoints[arrayLength],
                  points[0],
                  roofInfo,
                  gridInfo
                )}`}
                rotation={rotation(updatePoints[arrayLength], updatePoints[0])}
                fontFamily="italic"
                fontSize={10}
                fill={view === "satellite" ? "white" : "blue"}
                strokeWidth={1}
              />
            )}
        </>
      )}
      <Line
        points={area}
        fill={"red"}
        opacity={0.1}
        closed
      />
    </React.Fragment>
  ));
}



function calculateDistance(point1, point2, roofInfo, gridInfo){
  let pixelMultiple = getPixelsPerMeter(roofInfo);
  let distance =
    (Math.sqrt(
      Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2)
    ) *
      3.28084) /
    pixelMultiple;

  const scaleParameter = gridInfo.unit;

  if (scaleParameter === "m") {
    distance = (distance / 3.28084).toFixed(1);
    return `${distance}m`;
  } else {
    distance = distance.toFixed(1);
    return `${distance}ft`;
  }
}


function xPlacement(point1, point2, Points) {
  let lineMidpointY = (point2.x + point1.x) / 2;
  let firstPoint, secondPoint
  if(point1.x >= point2.x){
    firstPoint = point1
    secondPoint = point2
  }else{
    firstPoint = point2
    secondPoint = point1
  }

  let difference = secondPoint.x - firstPoint.x

  if(difference < 20){
    lineMidpointY += 5
  }

 

  return lineMidpointY;
}

function yPlacement(point1, point2, Points) {
  let lineMidpointY = (point2.y + point1.y) / 2;
  let firstPoint, secondPoint
  if(point1.y >= point2.y){
    firstPoint = point1
    secondPoint = point2
  }else{
    firstPoint = point2
    secondPoint = point1
  }

  let difference = secondPoint.y - firstPoint.y

  if(difference < 20){
    lineMidpointY += 5
  }

 

  return lineMidpointY;
}

function rotation(point1, point2) {
  let firstPoint, secondPoint
  if(point1.y >= point2.y){
    firstPoint = point1
    secondPoint = point2
  }else{
    firstPoint = point2
    secondPoint = point1
  }

  const slope = (firstPoint.y - secondPoint.y) / (firstPoint.x - secondPoint.x);
  const angleInRadians = Math.atan(slope);
  var angleInDegrees = (angleInRadians * 180) / Math.PI;

  return angleInDegrees;
}

